import { useCallback, useState, useContext } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { AuthContext } from 'components/context/AuthContext';

export const useFacebookLogin = () => {
  const { login, logout } = useContext(AuthContext);
  const navigate = useNavigate();
  const location = useLocation();

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const startFacebookLogin = useCallback(async () => {
    try {
      await logout();
      setLoading(true);
      setError(null);

      window.location.href = `${process.env.REACT_APP_API_URL}/facebook-auth/login`;
    } catch (err) {
      console.error('Error iniciando login con Facebook:', err);
      setError('Error iniciando login con Facebook.');
      setLoading(false);
    }
  }, [logout]);

  const handleFacebookCallback = useCallback(async () => {
    const params = new URLSearchParams(location.search);
    const jwtToken = params.get('token');
    const errorParam = params.get('error');
    const errorMsg = params.get('error_message');

    if (!jwtToken && !errorParam && !errorMsg) return;

    setLoading(true);
    setError(null);

    if (errorParam || errorMsg) {
      const msg = errorMsg || 'Hubo un problema con el inicio de sesión en Facebook.';
      console.warn('Error recibido del backend en callback de Facebook:', msg);
      setError(msg);
      navigate('/login', { replace: true, state: { fbError: msg } });
      return;
    }

    try {
      await login(jwtToken);
      navigate('/home');
    } catch (err) {
      console.error('Error iniciando sesión con el token de Facebook:', err);
      setError('Error al iniciar sesión con el token de Facebook.');
      navigate('/login', { replace: true });
    } finally {
      setLoading(false);
    }
  }, [location.search, login, navigate]);

  return {
    startFacebookLogin,
    handleFacebookCallback,
    loading,
    error,
  };
};

export default useFacebookLogin;
